// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[v-cloak] > *[data-v-70dce1f3] {\r\n\tdisplay: none !important;\n}\n#rootVM > .panel .panel-body .form-group[data-v-70dce1f3] {\r\n\tdisplay: flex;\r\n\talign-items: center;\n}\n#rootVM > .panel .panel-body .form-group label[data-v-70dce1f3] {\r\n\twidth: 60%;\r\n\tmargin-top: 5px;\n}\n#rootVM > .panel .panel-body .form-group input[data-v-70dce1f3] {\r\n\tmax-width: 200px;\r\n\tmargin-left: 15px;\n}\nlabel[data-v-70dce1f3] {\r\n\tmargin-right: 10px;\n}\r\n", ""]);
// Exports
module.exports = exports;
